import React, { ChangeEvent, useEffect, useState } from 'react';
import { FlatIcon } from '../../Icons/FlatIcon';
import useStyle from './checkbox.style';

export const Checkbox = ({
  initialValue,
  value,
  onChange,
  color = 'black'
}: {
  initialValue: boolean;
  value: string | number;
  onChange: (e: ChangeEvent) => void;
  color?: 'white' | 'black';
}) => {
  const classes = useStyle();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(initialValue);
  }, [initialValue]);

  const onChangeValue = e => {
    setChecked(!checked);
    onChange(e);
  };
  return (
    <div className={classes.root}>
      <input
        className={classes.checkbox}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChangeValue}
      />
      {checked && <FlatIcon icon={'Tick'} color={color} />}
    </div>
  );
};
